export enum ContactTypeEnum {
  Email = "EMAIL",
  Telefone = "TELEFONE",
  Site = "SITE",
}
